/** Canonical origin for production SEO; localhost preserved for local dev. */
export function getSiteOrigin(): string {
  if (typeof window === 'undefined') {
    return 'https://app.horseracingoracle.com';
  }
  if (window.location.hostname === 'app.horseracingoracle.com') {
    return 'https://app.horseracingoracle.com';
  }
  return window.location.origin;
}
